import { showDialog } from "../../../services/HelperService";
import LinkJobsDlg from "../../../dialogs/LinkJobsDlg";
import { update } from "../../../services/DataService";

export async function OpenLinkJobsDlg({ chatID, contactID, chatIntID, chatSubject, linkedJobs = [] }) {
    return showDialog(
        <LinkJobsDlg
            chatId={chatID}
            chatIntId={chatIntID}
            chatSubject={chatSubject}
            contactId={contactID ?? null}
            initialSelectedJobIds={(linkedJobs || []).map(j => j.JobID)}
            initialSelectedJobs={(linkedJobs || []).map(j => ({ id: j.JobID, ref: j.Reference }))}
            onDone={async ({ jobIds }) => {
                if (!Array.isArray(jobIds) || jobIds.length === 0) return;
                // bulk link (idempotent; server will enforce filtered unique index)
                await update("Chat_LinkJobs", { ChatID: chatID, JobIDs: jobIds });
                return jobIds;
            }}
        />
    );
}
